// extracted by mini-css-extract-plugin
export var actionButton = "_ka-t";
export var buttonContainer = "_ka-0";
export var buttonContainer2 = "_ka-1";
export var buttonSection = "_ka-2";
export var details = "_ka-3";
export var dropdownItem = "_ka-5";
export var dropdownItemsContainer = "_ka-4";
export var fileInput = "_ka-r";
export var headerButton = "_ka-6";
export var icon = "_ka-7";
export var input = "_ka-8";
export var macroListItem = "_ka-9";
export var mainContent = "_ka-a";
export var microText = "_ka-b";
export var modal = "_ka-w";
export var optionsButton = "_ka-c";
export var paperclip = "_ka-s";
export var pillContent = "_ka-d";
export var preview = "_ka-e";
export var preview2 = "_ka-f";
export var quillEditor = "_ka-q";
export var selectedMacro = "_ka-g";
export var sidebar = "_ka-h";
export var sidebarHeader = "_ka-j";
export var sidebarList = "_ka-i";
export var sidebarListItem = "_ka-k";
export var sidebarSearch = "_ka-l";
export var snoozeDurationWrapper = "_ka-v";
export var statusPillContainer = "_ka-m";
export var tagsContainer = "_ka-n";
export var unselectedMacro = "_ka-o";
export var variable = "_ka-u";
export var wrapper = "_ka-p";